exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-area{display:flex;width:90vw;max-width:600px;height:60px;justify-content:space-around;margin:0 auto 30px}.nav-area md-input-container{width:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/airportSelector/airportSelector.scss
// module id = 625
// module chunks = 0